const PROFILE_URL = 'profile/'

import { _get } from 'frontcore/utils/communications/apiClient'
import { LOGIN_CONSTANTS } from 'frontcore/constants/index'

class Auth {

  /**
   * Checks that the user token is saved in local storage.
   * @returns {boolean} Returns if the use has a token.
   */
  checkAuth () {
    return !!localStorage.getItem(LOGIN_CONSTANTS.TOKEN_KEY) || !!localStorage.getItem(LOGIN_CONSTANTS.ACCESS_TOKEN)
  }
  getAuthHeader () {
    const token = localStorage.getItem(LOGIN_CONSTANTS.ACCESS_TOKEN) || localStorage.getItem(LOGIN_CONSTANTS.TOKEN_KEY)
    return token ? `Token ${token}` : null
  }
  checkImpersonate () {
    return !!localStorage.getItem(LOGIN_CONSTANTS.IMPERSONATE_KEY)
  }
  clearToken () {
    localStorage.removeItem(LOGIN_CONSTANTS.TOKEN_KEY)
    localStorage.removeItem(LOGIN_CONSTANTS.ACCESS_TOKEN)
  }
  getImpersonateHeader () {
    if (localStorage.getItem(LOGIN_CONSTANTS.IMPERSONATE_KEY)) {
      return `Impersonate ${localStorage.getItem(LOGIN_CONSTANTS.IMPERSONATE_KEY)}`
    }
    return null
  }
  impersonateUser (user, url=PROFILE_URL) {
    const token = this.getAuthHeader()
    const impersonate = 'Impersonate ' + user
    return _get(url, { headers: { Authorization: token, Impersonate: impersonate }})
      .then((profile) => {
        localStorage.setItem(LOGIN_CONSTANTS.IMPERSONATE_KEY, user)
        return profile
      })
  }
  finishImpersonating (url=PROFILE_URL) {
    const token = this.getAuthHeader()
    localStorage.removeItem(LOGIN_CONSTANTS.IMPERSONATE_KEY)
    return _get(url, { headers: { Authorization: token }})
  }
  
}

export default new Auth()
